import { useAtomValue } from 'jotai';
import { userConfig } from '~/global-state/userConfig';

export function useDealsEnabled(): boolean {
  const config = useAtomValue(userConfig);
  return config.dealsEnabled;
}
